/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * BfAlertLevel: The level of alert for an event.
 */

export const BfAlertLevel = {
    unknown: 'unknown',
    notApplicable: 'notApplicable',
    communityUpdate: 'communityUpdate',
    advice: 'advice',
    watchAndAct: 'watchAndAct',
    emergencyWarning: 'emergencyWarning',
    evacuateImmediately: 'evacuateImmediately'
} as const;

export type BfAlertLevel = typeof BfAlertLevel[keyof typeof BfAlertLevel];



